// extracted by mini-css-extract-plugin
export default {"card":"Commit_card__fSLKT"};